import $ from 'jquery';
import { axiosInstance as axios, handleAxiosErrors } from '../../_utils';
import { requestUserStripeInfo, toggleLoading } from '../userActions';
import config from '../../store/_config';

export const setStripeFieldData = (value) => {
    return {
        type: 'SET_STRIPE_FIELD_DATA',
        value: value,
    };
};

/**
 * Request Wholesaler Reseller
 */
export const requestStripeMissingFields = () => {
    return (dispatch, getState) => {
        const state = getState().user;

        if(state.loggedIn) {
            dispatch(toggleLoading('stripeFields', true));

            return axiosRequestStripeMissingFields()
                .then((response) => {
                    console.log(response);
                    let fieldData = response.data.data.readStripeConnectExtraFields.Data;
                    const fields = (typeof(fieldData) == 'string') ? JSON.parse(fieldData) : fieldData;

                    dispatch(setStripeFieldData(fields));

                    return dispatch(requestUserStripeInfo());
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                })
                .finally(() => {
                    dispatch(toggleLoading('stripeFields', false));
                });
        }

        return false;
    };
};

export const axiosRequestStripeMissingFields = () => {
    let { url, query } = config.user.stripeConnectExtraFields;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};


export const requestPayFastMissingFields = () => {
    return (dispatch, getState) => {
        const state = getState().user;

        if(state.loggedIn) {
            dispatch(toggleLoading('stripeFields', true));

            return axiosRequestPayFastMissingFields()
                .then((response) => {
                    console.log(response);
                    let fieldData = response.data.data.readPayFastExtraFields.Data;
                    const jsonData = JSON.parse(response.data.data.readPayFastExtraFields.Data);
                    console.log('jsonData===============',jsonData,jsonData[0]);
                    const jsonDataExtraFields = jsonData[0]; 
                    const fields = jsonDataExtraFields; 

                    dispatch(setStripeFieldData(fields));

                    return dispatch(requestUserStripeInfo());
                })
                .catch((error) => {
                    handleAxiosErrors(error);
                })
                .finally(() => {
                    dispatch(toggleLoading('stripeFields', false));
                });
        }

        return false;
    };
};

export const axiosRequestPayFastMissingFields = () => {
    let { url, query } = config.user.payFastConnectExtraFields;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosStripeUploadImage = (acceptedImages) => {
    let { url, query } = config.stripe.uploadImage;

    let formData = new FormData();

    if (typeof window.SecurityToken != 'undefined') {
        formData.set('SecurityID', window.SecurityToken);
    }

    acceptedImages.forEach((file) => {
        formData.append('Upload', file);
    });

    return axios
        .post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            withCredentials: true,
        })
        .catch((error) => {
            handleAxiosErrors(error);
        });
};

export const axiosRequestPayoutLogs = (params = null) => {
    let { url, query } = config.stripe.payoutLogs;

    let data = {
        query: query,
        variables: params,
    };

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
            variables: params,
        },
    });
};

export const axiosRequestPayFastPayoutLogs = (params = null) => {
    let { url, query } = config.payfast.payoutLogs;

    let data = {
        query: query,
    };

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const handleStripeWarning = () => {
    return (dispatch, getState) => {
        const state = getState();
        let $stripeWarning = $('#stripe-warning');

        const userInfo = state.user.info;

        if(userInfo && userInfo.basicInfo !== undefined) {
            const stripeConnectStatus = userInfo.basicInfo.IsStripeConnectComplete || false;

            if ($stripeWarning.length) {
                console.log('stripeConnectStatus', stripeConnectStatus);

                if (stripeConnectStatus) {
                    $('#stripe-warning').slideUp();
                } else {
                    $('#stripe-warning').slideDown();
                }
            }
        }

    };
};
